export enum TcrCampaignStage {
  CAMPAIGN_ADD = 'CAMPAIGN_ADD',
  CAMPAIGN_SHARE_ACCEPT = 'CAMPAIGN_SHARE_ACCEPT',
  CAMPAIGN_DCA_COMPLETE = 'CAMPAIGN_DCA_COMPLETE',
  CAMPAIGN_SHARE_DELETE = 'CAMPAIGN_SHARE_DELETE'
}
